<template>

  <div class="padded">
    <component :is="titleStyle">{{title}}</component>
    <span class="pull-right" >
      <el-button size="mini" type="primary" @click="openAddForm">Add</el-button>
      &nbsp;
      <el-button size="mini" v-if="formList && formList.length > 0" type="success" @click="saveForm">Save</el-button>
    </span>

    <el-dialog :title="formTitle" :visible.sync="showForm">

      <form-editor v-model="form"  />

      <span slot="footer" class="dialog-footer">
        <el-button @click="clearForm">Cancel</el-button>
        <el-button type="success" @click="addFormItem" :disabled="!form.dataType && !form.label">Save</el-button>
      </span>
    </el-dialog>


    <section v-if="formList && formList.length > 0">
      <el-tabs>
         <el-tab-pane label="Design">
          <el-table :data="formList" style="width: 100%;" :class="tableStyle">

            <el-table-column type="expand">
              <template slot-scope="props">
                <form-editor v-model="props.row" />
              </template>
            </el-table-column>


            <el-table-column label="Label" prop="label">
              <template slot-scope="scope">
                {{ellipsis(scope.row.label)}}&nbsp;<i :class="scope.row.required ? 'fa fa-star' : ''"></i>
              </template>
            </el-table-column>

            <el-table-column label="Type" prop="dataType">
              <template slot-scope="scope">
                {{scope.row.dataType}}&nbsp;
                <span v-if="scope.row.gutter" class="text-muted">&nbsp;[{{scope.row.gutter}}]</span>
                <span v-if="scope.row.span" class="text-muted">&nbsp;[{{scope.row.span}}]</span>
                <span v-if="scope.row.decimals" class="text-muted">&nbsp;[{{scope.row.decimals}}]</span>
                <span v-if="scope.row. list && scope.row.list.length > 0" class="text-muted">&nbsp;{{scope.row.list}}</span>
              </template>
            </el-table-column>

            <el-table-column label="" fixed="right">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  circle
                  @click="deleteItem(scope.$index, scope.row)"><i class="fa fa-trash-alt"></i></el-button>
              </template>
            </el-table-column>
          </el-table>

          <JSONView :data="formList" />
      </el-tab-pane>

      <el-tab-pane label="Preview">
        <form-viewer v-model="this.formList" />
      </el-tab-pane>

    </el-tabs>

    </section>

  </div>

</template>

<script>

import ArrayMixins from '@/mixins/ArrayMixins'
import FormattingMixins from '@/mixins/FormattingMixins'
import { JSONView } from 'vue-json-component'

import FormEditor from '@/components/atoms/forms/FormEditor'
import FormViewer from '@/components/atoms/forms/FormViewer'

export default {
  name: 'form-builder',

  mixins: [ArrayMixins, FormattingMixins],

  components: {
    FormEditor,
    FormViewer,
    JSONView
  },

  props: {
    title: {
      type: String,
      default: 'Form Builder'
    },

    titleStyle: {
      type: String,
      default: 'big'
    },

    tableStyle: {
      type: String
    },

    value: {
      required: true
    }
  },

  methods: {

    clearForm (isAdd = false) {

      if (isAdd) {
        this.formTitle = 'Add New Item'
      }

      this.form = {}

      this.showForm = false
    },



    addFormItem () {

      if (this.form.dataType !== 'number-input') {
        delete this.form.decimals
      }

      if (this.form.dataType !== 'select-input') {
        delete this.form.list
      }

      if (!this.isLayout(this.form.dataType)) {
        this.form.prop = this.label
      } else {
        this.form.children = []
      }

      this.formList.push(this.clone(this.form))
      this.clearForm(true)
    },



    openAddForm () {
      this.showForm = true
    },



    saveForm () {
      // this.$message({type: 'info', description: 'Save clicked'})
      console.log(this.value)
      this.localValue.formList = this.formList
    },



    editItem (index, row) {
      this.form = {}
      this.form = row
      this.showForm = true
    },



    deleteItem (index, row) {
      this.$confirm('This will permanently delete <b>the form item: ' +
       (row.label ? row.label : '') + (row.dataType ? '[' + row.dataType + ']' : '') +
        '</b> Continue?', 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          center: true,
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          this.arrayRemove(this.formList, index)
        })

    },

    isLayout (dataType) {
      return (dataType === 'el-row' || dataType === 'el-col' || dataType === 'h3' || dataType === 'text-area')
    }

  },



  data () {
    return {
      formTitle: 'Add New Item',
      showForm: false,
      form: {label: null, dataType: {value: 'text-input', label: 'Text'}},
      formList: this.value.formList ? this.value.formList : [],
      localValue: this.value
    }
  },

  created () {
    console.log('formList', this.formList)
  }

}

</script>

<style scoped>
.el-table {width: inherit; max-width: 1024px;}
.add-form-item {padding: 1em; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);}
</style>



// WEBPACK FOOTER //
// FormBuilder.vue?d0be04ec